import { render, staticRenderFns } from "./ApprovalLeave.vue?vue&type=template&id=5f1ab592&scoped=true"
import script from "./ApprovalLeave.vue?vue&type=script&lang=js"
export * from "./ApprovalLeave.vue?vue&type=script&lang=js"
import style0 from "./ApprovalLeave.vue?vue&type=style&index=0&id=5f1ab592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1ab592",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCol,VDataTable,VDatePicker,VMenu,VPagination,VRow,VTextField,VTextarea})
